import React from "react";
import "../styles/InfoDocumentos.css";
import { useAuth } from "../context/AuthContext.jsx";
import FileManager from "./FileManager.jsx";
import { ScrollText } from 'lucide-react';

const InfoOrdenanzas = () => {
  const { isAdmin } = useAuth();
  return (
      <div className="doc-page-container" style={{'--doc-color': '#17a589', '--doc-bg-color': '#f0fcf9'}}>
        <div className="doc-page-card">
          <div className="doc-page-header">
            <div className="doc-page-icon"><ScrollText size={48} /></div>
            <h2 className="doc-page-title">Ordenanzas</h2>
          </div>
          <p className="doc-page-text">Desde la <strong>Comuna de Santo Domingo</strong>, ponemos a disposición las ordenanzas municipales vigentes.</p>
          <FileManager tableName="ordenanzas_files" folderName="ordenanzas" bucketName="ordenanzas" isAdmin={isAdmin} />
        </div>
      </div>
  );
};
export default InfoOrdenanzas;